import { render } from "./HoldsList.vue?vue&type=template&id=2c763f02&scoped=true"
import script from "./HoldsList.vue?vue&type=script&lang=js"
export * from "./HoldsList.vue?vue&type=script&lang=js"

import "./HoldsList.vue?vue&type=style&index=0&id=2c763f02&scoped=true&lang=css"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c763f02"]])

export default __exports__